import { ApiListRelationship, ApiModel, ApiRelationship } from 'lib/interfaces/api';
import { RelationSchema } from 'lib/relations';

export function createPreviewRelation(
  relationSchema: RelationSchema,
): Record<string, ApiRelationship | ApiListRelationship> {
  switch (relationSchema.type) {
    case ApiModel.AccountType:
      return {
        [`${relationSchema.key}`]: {
          data: [{ type: ApiModel.Account, id: 'act_123' }],
        },
      };
    case ApiModel.TransactionType:
      return {
        [`${relationSchema.key}`]: {
          data: [{ type: ApiModel.Transaction, id: 'txn_123' }],
        },
      };
    default:
      return { [`${relationSchema.key || 'object_relations'}`]: { data: [] } };
  }
}
